var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative"}},[_c('van-overlay',{staticStyle:{"z-index":"2100"},attrs:{"show":_vm.show}},[_c('div',{staticClass:"block"},[_c('div',{staticClass:"loading__image loading__box",style:({
          backgroundImage: 'url(' + _vm.imgLoading.value + ')',
        })})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }